export enum FirebaseConnectionOutcome {
  Connected = 'connected',
  Timeout = 'timeout',
  Failed = 'failed',
}

export enum FirebaseConnectionContext {
  AgentConsoleDefault = 'agent-console-default',
  ChatbotChat = 'chatbot-chat',
  ChatbotAiIntervention = 'chatbot-ai-intervention',
}

export enum FirebaseConnectionStatus {
  Pending = 'pending',
  Connected = 'connected',
  Timeout = 'timeout',
  Failed = 'failed',
}

export const FIREBASE_CONNECTION_STATUS_BY_OUTCOME: Record<FirebaseConnectionOutcome, FirebaseConnectionStatus> = {
  [FirebaseConnectionOutcome.Connected]: FirebaseConnectionStatus.Connected,
  [FirebaseConnectionOutcome.Timeout]: FirebaseConnectionStatus.Timeout,
  [FirebaseConnectionOutcome.Failed]: FirebaseConnectionStatus.Failed,
};
